import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.assetManagement || initialState;

export const selectKitLists = createSelector(
  [selectDomain],
  (state) => state.kitLists
);

export const selectKitListsCount = createSelector(
  [selectDomain],
  (state) => state.kitListsCount
);
 
export const selectStates = createSelector(
  [selectDomain],
  (state) => state.states
);

export const selectDistricts = createSelector(
  [selectDomain],
  (state) => state.districts
);

export const selectFilterDistricts = createSelector(
  [selectDomain],
  (state) => state.filterDistricts
);

export const selectAgencies = createSelector(
  [selectDomain],
  (state) => state.agencies
);

export const selectFilterStatus = createSelector(
  [selectDomain],
  (state) =>state.filterStatus
);

export const selectProjects = createSelector(
  [selectDomain],
  (state) =>state.projects
);
export const selectSamplers = createSelector(
  [selectDomain],
  (state) =>state.samplers 
);
export const selectFilterSamplers = createSelector(
  [selectDomain],
  (state) =>state.filterSamplers 
); 

export const selectKitDataAfterKitCreation = createSelector(
  [selectDomain],
  (state) => state.kitDataAfterKitCreation
);

export const selectLogisticList = createSelector(
  [selectDomain],
  (state) =>  state.logisticList
);

export const selectSampleSealTypes = createSelector(
  [selectDomain],
  (state) => state.sealTypes
);